import React from "react";

function Footer() {
  return (
    <div className="mt-5 bg-dark text-light p-5 text-center">
      &copy; All Rights Reserved 2023 || Made by Me with ❤️
    </div>
  );
}

export default Footer;
